import RedirectException from "found/lib/RedirectException";

import {
  PageNotFound404Error,
  PermissionDenied403Error
} from "pstat-anywhere/errors";

const DEFAULT_API_URL = "/graphql/?";
const ROOT_URL = "";

const getAPIUrl = () => process.env.API_URL || DEFAULT_API_URL;

const getRootUrl = () => ROOT_URL;

const isDevMode = () => process.env.NODE_ENV === "development";

export { getAPIUrl, getRootUrl, isDevMode };

export const checkForRedirect = (
  props,
  queryName,
  includeCurrentQueryString = false
) => {
  if (props && props[queryName]) {
    let redirectUrl = props[queryName].redirectUrl;
    if (redirectUrl) {
      if (includeCurrentQueryString) {
        const queryString = props.location.search;
        redirectUrl += queryString;
      }
      throw new RedirectException(redirectUrl);
    }
  }
};

export const checkForError = (props, queryName) => {
  if (props && props[queryName]) {
    const queryProps = props[queryName];
    const error = queryProps.error;
    if (error) {
      if (error.statusCode === 404) {
        throw new PageNotFound404Error();
      } else if (error.statusCode === 403) {
        throw new PermissionDenied403Error(error.message, {
          tenantsToRedirect: queryProps?.tenantsToRedirect,
          documentPk: props?.params?.documentPk
        });
      } else {
        throw new Error();
      }
    }
  }
};

export const getUrl = urlPath => {
  if (isDevMode()) {
    return `http://dmi-scranton.policystat.localhost:8000${urlPath}`;
  }
  return urlPath;
};
